fx.ns("repositories", class GoogleRepository extends fx.ModelArray {

	constructor()
	{
		super([]);
	}

	get requestDefaultParams()
	{
		return {connectionid : fx.get("connectionid")};
	}

	get currentAlbum()
	{
		let currentAlbum = [];

		for (let i = 0; i < this.length; i++)
		{
			if (this.getItemAt(i).isActive)
			currentAlbum.push(this.getItemAt(i));
		}

		return currentAlbum[0];
	}

	get selectedPhotos()
	{
		let selectedItems = [];

		for (let i = 0; i < this.length; i++)
		{
			let albumPhotos = this.getItemAt(i).photos;

			for (let j = 0; j < albumPhotos.length; j++)
			{
				if (albumPhotos.getItemAt(j).selected)
				selectedItems.push(albumPhotos.getItemAt(j));
			}
		}

		return selectedItems;
	}

	addAlbum(rawAlbum)
	{
		let album = new fx.ModelArray();
		//rawAlbum._m = "GoogleAlbumModel";
		album.addItem(rawAlbum);
		this.addItem(album);

	}

	addPhoto(album, rawPhoto)
	{
		//rawPhoto._m = "GooglePhotoModel";

		if (!album.photos) 
			album.photos = new fx.ModelArray([]);

		album.photos.addItem(rawPhoto);
	}

	selectAllCurrentAlbumPhotos()
    {
		if (!this.currentAlbum) return;

		let currentAlbumPhotos = this.currentAlbum.photos;
		
		for ( let i = 0; i < currentAlbumPhotos.length; i++)
		{
			currentAlbumPhotos.getItemAt(i).selected = true;
		}
    }
	
    unSelectAllCurrentAlbumPhotos()
    {
		if (!this.currentAlbum) return;
		
		let currentAlbumPhotos = this.currentAlbum.photos;

        for ( let i = 0; i < currentAlbumPhotos.length; i++)
		{
			currentAlbumPhotos.getItemAt(i).selected = false;
		}
	}
	
	unSelectAllPhotos()
	{
		for (let i = 0; i < this.length; i++)
		{
			let currentAlbumPhotos = this.getItemAt(i).photos;

			for (let j = 0; j < currentAlbumPhotos.length; j++)
			{
				currentAlbumPhotos.getItemAt(j).selected = false;
			}
		}
	}

	getServerPhotos(googlePhotos)
	{
		if (googlePhotos)
			this._selectedPhotos = googlePhotos;
		else
			googlePhotos = this.selectedPhotos;

		this.on("google-convert-finished", this._getServerPhotos, fx.service("GoogleConvertService"));
		this.on("google-converting", this._onConverting, fx.service("GoogleConvertService"));
		
		fx.service("GoogleConvertService").convert(googlePhotos);
	}

	_onConverting(event)
	{
		this.event("google-selected-photos-sent", event.detail);
	}

	_getServerPhotos(event)
	{
		if (event.detail.error)
		{
			this.event("google-selected-photos-error");
		}
		else
		{
			//let selectedPhotos = this.selectedServerPhotos(data);
			//this.event("google-selected-photos-ready", selectedPhotos);
			this.event("google-selected-photos-ready", event.detail);
			this._selectedPhotos = null;
		}

		this.off("google-convert-finished", this._getServerPhotos, fx.service("GoogleConvertService"));
		this.off("google-converting", this._onConverting, fx.service("GoogleConvertService"));
	}

	selectedServerPhotos(serverData)
	{
		let selectedItems = [];
		let selectedPhotos = this._selectedPhotos || this.selectedPhotos;
		for (let i = 0; i < selectedPhotos.length; i++)
		{
			let {baseUrl, fullSize_url, id, mediaMetadata, thumb} = selectedPhotos[i]; 

			if (serverData[i])
				selectedItems.push( { 
									server_url: serverData[i].url,
									baseUrl,
									fullSize_url : fullSize_url,
									id,
									//height: mediaMetadata.height,
									//width: mediaMetadata.width,
									thumb,
									metaData : mediaMetadata
								});
		}
		return selectedItems;
	}
	
});